import { avagClient } from "$api/client";
import { useMutation } from "@tanstack/react-query";

export const usePostField = (locationId) => {
  return useMutation({
    mutationFn: async (body) => {
      return await avagClient.post(`/locations/${locationId}`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
  });
};
